export default __webpack_public_path__ + "static/media/3.5b7444ce.png";